import { Input } from "common/InputForm";
import useButtonLoader from "common/UseButtonLoader";
import { CustomModal } from "components/modals/ModalBox";
import { useState } from "react";
import { editBrandApi } from "services/brand";
import { toastMessage } from "utils/toastMessage";
export const EditProductBrandModel = ({
  setEditModal,
  editModal,
  brandListHandler,
  inputData,
  setInputData,
}) => {
  const [errors, setErrors] = useState({});
  const [disable, setDisable] = useState("false")
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Add");
  const validation = () => {
    let isValid = true;
    const error = {};
    if (!inputData.name) {
      error["name"] = "Please enter a Brand name";
      isValid = false;
    }
    if (!inputData.brandType) {
      error["brandType"] = "Please select a Brand Type";
      isValid = false;
    }
    if (!inputData.logo) {
      error["logo"] = "Please select logo";
      isValid = false;
    }
    if (!inputData.orderNumber) {
      error["orderNumber"] = "Please select orderNumber";
      isValid = false;
    }
    setErrors(error);
    return isValid;
  };
  const onChangeHandler = (e) => {
    setDisable("true")
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };
  const editBrand = async (e) => {
    e.preventDefault();
    if (validation()) {
      setButtonLoaders(true);
      try {
        const formData = new FormData();
        formData.append("id", inputData._id)
        formData.append("name", inputData.name);
        formData.append("orderNumber", inputData.orderNumber)
        formData.append("type", "product");
        const res = await editBrandApi(formData);
        if (res?.data?.status === 200) {
          toastMessage(res?.data?.message, "success", "editBrand");
          setDisable("false")
          setEditModal(false);
          brandListHandler();
        } else {
          toastMessage(res?.data?.message, "error", "editBrand");
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoaders(false);
      }
    }
  };

  return (
    <CustomModal
      className={"add_model"}
      show={editModal}
      handleClose={() => {
        setEditModal(false);
        setErrors({});
      }}
    >
      <h3>Edit Brand</h3>
      <div className="add_model">
        {/* Brand Name */}
        <div className="form_field">
          <Input
            className={"form-control input"}
            label={"Brand Name"}
            type={"text"}
            value={inputData.name || ""}
            onChange={onChangeHandler}
            placeholder={"Enter Brand Name"}
            name={"name"}
            error={errors?.name}
          />
        </div>
        <div className="form_field">
          <Input
            className={"form-control input"}
            label={"Order Number"}
            type={"number"}
            value={inputData.orderNumber || ""}
            onChange={onChangeHandler}
            placeholder={"Enter Order Number"}
            name={"orderNumber"}
            error={errors?.orderNumber}
          />
        </div>
      </div>
      <div className="button_wrap">
        <button
          type="button"
          className="button light"
          onClick={() => setEditModal(false)}
        >
          Cancel
        </button>
        {disable === "true" ?

          <button
            type="button"

            ref={buttonLoaders}
            onClick={editBrand}
            className="button"
          >
            Edit
          </button> :
          <button
            type="button"
            className="button"
          >
            Edit
          </button>

        }
      </div>
    </CustomModal>
  );
};
